import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Distribution from '../entities/distribution';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Vuex from 'vuex';
Vue.use(Vuex);

interface DistributionState extends ListState<Distribution> {
}
class DistributionModule extends ListModule<DistributionState, any, Distribution> {
    enshopid = Util.siss.auth.getenshopid();
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Distribution>(),
        loading: false,
        commission:0,
        isshowdistribution: localStorage[this.enshopid + '_isshowdistribution']
    };
    public actions = {
        async getdistributionIncome(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetdistributionIncome');
            let result = reponse.data.result;
            return result;
        },
        async getDistributionPlanWidthDetailsByPages(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionPlanWidthDetailsByPages',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
        async getDistributionWxaUserData(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionWxaUserData');
            let result = reponse.data.result;
            return result;
        },
        async getDistributionWxaUserByPages(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionWxaUserByPages',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
        async getDistributionOrderDetails(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionOrderDetails',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
        async getDistributionIncomerecord(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionIncomerecord',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
        async getDistributionProducts(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionProducts');
            let result = reponse.data.result;
            return result;
        },
        async getDistributionRights(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionRights');
            let result = reponse.data.result;
            return result;
        },
        async getIsDistributorByOrderNo(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetIsDistributorByOrderNo?orderno='+payload.data.orderno);
            let result = reponse.data.result;
            return result;
        },
        async getDistributionOrderStateData(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionOrderStateData');
            let result = reponse.data.result;
            return result;
        },
        async cashDistributionIncome(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Distribution/CashDistributionIncome?amount='+payload.data.amount);
            let result = reponse.data.result;
            return result;
        },
        async getDistributionGoodsFlag(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetDistributionGoodsFlag',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
        async getCurrentDistributionGoods(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Distribution/GetCurrentDistributionGoods');
            let result = reponse.data.result;
            return result;
        },
         //活动隔离-满减
         async getCurrentDistributionGoods_MobileBuyFull(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetCurrentDistributionGoods');
            let result = reponse.data.result;
            return result;
        },
        //活动隔离-满减
        async getDistributionGoodsFlag_MobileBuyFull(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetDistributionGoodsFlag',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
         //活动隔离-拼团
         async getCurrentDistributionGoods_MobilePintuan(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetCurrentDistributionGoods');
            let result = reponse.data.result;
            return result;
        },
        //活动隔离-拼团
        async getDistributionGoodsFlag_MobilePintuan(context: ActionContext<DistributionState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetDistributionGoodsFlag',{params:payload.data});
            let result = reponse.data.result;
            return result;
        },
    };
    public mutations = {
        setCurrentPage(state: DistributionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: DistributionState, pagesize: number) {
            state.pageSize = pagesize;
        },
        updateCommission(state: DistributionState, commission: any) {
            state.commission = commission;
        },
        setDistribution(state:DistributionState, data:string) {
            state.isshowdistribution = data;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_isshowdistribution",data);
        }
    };
}
const distributionModule = new DistributionModule();
export default distributionModule;
